/**
 * Theme styles for the AddToCartConfirmationDrawer component.
 * All values reference design tokens — no hardcoded colors.
 */
export default {
    parts: [
        'shippingBarWrapper',
        'itemSummary',
        'itemImageBox',
        'itemMeta',
        'itemName',
        'itemAttr',
        'itemPrice',
        'ctaWrapper',
        'fbtSection',
        'fbtTitle',
        'fbtCard',
        'fbtCardSkeleton',
        'fbtImageWrapper',
        'fbtProductName',
        'fbtQuickViewButton'
    ],
    baseStyle: {
        shippingBarWrapper: {
            p: 0,
        },
        itemSummary: {
            direction: 'row',
            gap: 4,
            mb: 8
        },
        itemImageBox: {
            flexShrink: 0,
            width: '96px'
        },
        itemMeta: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        itemName: {
            textStyle: 'bodyMdRegular',
            color: 'webTypo.textPrimary'
        },
        itemAttr: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textSecondary'
        },
        itemPrice: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textPrimary',
            mt: 2
        },
        ctaWrapper: {
            mb: 8
        },
        fbtSection: {
            mt: 0
        },
        fbtTitle: {
            textStyle: 'webH3',
            color: 'webTypo.textPrimary',
            mb: 4
        },
        fbtCard: {
            position: 'relative',
            cursor: 'pointer'
        },
        fbtCardSkeleton: {
            height: '220px',
            borderRadius: 'sm'
        },
        fbtImageWrapper: {
            position: 'relative',
            overflow: 'hidden',
            mb: 2
        },
        fbtProductName: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textPrimary',
            mb: 1
        },
        fbtQuickViewButton: {
            position: 'absolute',
            bottom: 2,
            right: 2,
            zIndex: 2,
            variant: 'unstyled',
            width: '32px',
            height: '32px',
            minWidth: '32px',
            borderRadius: 'full',
            bg: 'webTheme.layerDefault',
            border: '1px solid',
            borderColor: 'webTheme.strokeDefault',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'opacity 150ms ease',
            _hover: {
                bg: 'webTheme.layerHover'
            }
        }
    }
}
